'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { TerminalDashboard } from '@/components/terminal/TerminalDashboard';
import './terminal.css';

export default function TerminalPage() {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30000,
        retry: 1,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: false,
      },
    },
  }));

  return (
    <QueryClientProvider client={queryClient}>
      <TerminalDashboard />
    </QueryClientProvider>
  );
}
